const doc = [({"da":({"js":({"admin":({"school_classes":({"table":({"people_count":"Antal kontakter"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;